import {
  SET_RTT_REFERENCES
} from './mutationTypes';

import { setActionStatusError, setActionStatusSuccess, setActionStatusPending, resetActionStatus } from '@/store/helpers';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  resetActionStatus,
  [SET_RTT_REFERENCES](state, rttReferences) {
    state.rttReferences = rttReferences;
  }
};